export default "__VITE_ASSET__FzWRW3SR__"